import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Verzió előzmények")
        ]),
        _: 1
      }),
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedVersions, (version) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
              key: version.versionNumber
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      class: "w-100",
                      "no-gutters": "",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, "Verzió " + _toDisplayString(version.versionNumber), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { class: "text-end" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString($setup.formatDateTime(version.updatedAt)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: $setup.itemHeaders,
                      items: version.items,
                      "item-key": "id",
                      density: "compact"
                    }, {
                      "item.retailPrice": _withCtx(({ value }) => [
                        _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                      ]),
                      "item.grossPricePerPersonPerNight": _withCtx(({ value }) => [
                        _createTextVNode(_toDisplayString($setup.formatPrice(value)), 1)
                      ]),
                      _: 2
                    }, 1032, ["items"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}